














































































































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import { useStdCreativeAdgroupIs, useAdgroupMode, useStdAdgroupOptimizationGoal } from '@tt4b/ttam-hooks';
import CreativeDestinationType from './index';
import TtamLearnMore from '@/components/common/learn-more/index.vue';
import {
  CampaignFormData,
  AcoFormData,
  AdgroupFormData,
  FullNormalFormData,
  genDestinationUrlTypes,
  genDestinationUrlTypesConfig,
  CreateMode,
  DestinationUrlType,
  AdAppType,
  CampaignIOSType,
  CampaignObjectiveType,
} from '@tt4b/ttam-enums';
import { trackEvent } from '@tt4b/ttam-utils';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-creative-destination-type-compose';
export default defineComponent({
  name,
  components: {
    TtamLearnMore,
    TtamDestinationTypeSelectorTab: CreativeDestinationType.TtamDestinationTypeSelectorTab,
    // TtamCustomProductPageSwitch: CreativeDestinationType.TtamCustomProductPageSwitch,
  },
  props: {
    // 必传
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    // 必传
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    // 必传
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    // 是否是SPC 用于展示文案 Product可不传
    isSpc: {
      type: Boolean,
      default: false,
    },
    // 禁用tab选项
    disabledSelectorTab: {
      type: Boolean,
      default: false,
    },
    // reach/vv下 CTA开关是否是关闭状态 Product可不传
    isClosedCta: {
      type: Boolean,
      default: false,
    },
    // 是否应该展示 webiste/app 对应的tab项
    showWebsite: {
      type: Boolean,
      default: true,
    },
    // 是否应该展示 instant page对应的tab项
    showInstantPage: {
      type: Boolean,
      default: false,
    },
    isAppProfileInstantPage: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    hasShopAnchor: {
      type: Boolean,
      default: false,
    },
    disabledText: {
      type: String,
      default: '',
    },
  },
  setup(props, ext) {
    const {
      isSpc,
      adgroupData,
      campaignData,
      creativeData,
      showWebsite,
      showInstantPage,
      isAppProfileInstantPage,
      createMode,
      hasShopAnchor,
      disabledSelectorTab,
      isClosedCta,
    } = toRefs(props);

    const { isEdit } = useAdgroupMode({
      createMode,
    });

    // 用于埋点参数
    const promotionWebsiteType = computed(() => adgroupData.value?.promotionWebsiteType);

    // 是否选中：destinationUrlType
    const getIsActive = typeNname => {
      if (typeNname === genDestinationUrlTypes().PRODUCT_PAGE.name) {
        return true;
      }
      return creativeData.value?.destinationUrlType === typeNname;
    };

    // 切换对应destinationUrlType字段，domain是为什么
    const setDestinationUrlType = typeNname => {
      ext.emit('change', {
        destinationUrlType: typeNname,
        domain: '',
      });
    };

    const getDisabledTabText = (typeName: string) => {
      if (props.isClosedCta || !props.disabledText) {
        return '';
      }

      if (props.disabledText && !getIsActive(typeName)) {
        return props.disabledText;
      }

      return '';
    };

    // 可以从公共hooks中直接获取的
    const {
      isAndroidApp,
      isLeadAdsInstantForm,
      isProductSales,
      isPromotionChoose,
      isAppDownload,
      isEngagementPageVisit,
      isLeadAdsPhoneCall,
      isLeadAdsSocialMediaAppMessage,
      isOptGoalDestinationVisit,
    } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isOptGoalConversation } = useStdAdgroupOptimizationGoal({
      adgroupFormData: adgroupData,
    });

    // 用于埋点参数
    const optimizationLocation = computed(() => {
      if (isLeadAdsSocialMediaAppMessage.value) {
        return 'social_media_app';
      }
      if (isLeadAdsPhoneCall.value) {
        return 'phone_call';
      }
      return '';
    });

    const showAppTitle = computed(() => isPromotionChoose.value || isAppDownload.value);

    const tipHoverText = computed(() => {
      if (hasShopAnchor.value) {
        return i18n.t('module_creative_anchor_destination_tip');
      }
      if (isLeadAdsInstantForm.value) {
        return i18n.t('module_lead_ads_form_text');
      }

      if (isAppProfileInstantPage.value) {
        return i18n.t('module_ad_app_profile_form_sub_title');
      }

      if (isPromotionChoose.value && !isSpc.value) {
        return i18n.t('module_custom_promotion_instant_page_introduce');
      }

      return i18n.t('module_custom_instant_page_introduce');
    });

    const getDestinationVisitTipHoverText = typeName => {
      if (typeName === DestinationUrlType.destinationVisitUniversalLink) {
        return i18n.t('creative_destination_universal_link_page_introduce');
      }
      return i18n.t('creative_destination_scheme_link_page_introduce');
    };

    // 得到分为webSite和instantPage的数组，app 属于webSite的一种，icon不一样
    const destinationUrlTypeOptions = computed(() =>
      Object.values(
        genDestinationUrlTypesConfig({
          isEdit: isEdit.value,
          currentDestinationUrlType: creativeData.value?.destinationUrlType as DestinationUrlType,
          isInstantForm: isLeadAdsInstantForm.value,
          showAppTitle: showAppTitle.value,
          isAndroidApp: isAndroidApp.value,
          isProductPage: isProductSales.value,
          showWebsite: showWebsite.value,
          showInstantPage: showInstantPage.value,
          isAppProfileInstantPage: isAppProfileInstantPage.value,
          isSupportPlayable: false,
          isEngagementPageVisit: isEngagementPageVisit.value,
          isLeadAdsPhoneCall: isLeadAdsPhoneCall.value,
          isLeadAdsSocialMediaAppMessage: isLeadAdsSocialMediaAppMessage.value,
          hasShopAnchor: hasShopAnchor.value,
          isOptGoalDestinationVisit: isOptGoalDestinationVisit.value,
          isOptGoalConversation: isOptGoalConversation.value,
        }),
      ).filter(item => !item?.hide),
    );

    const checkIsShowToolTip = typeName =>
      (typeName === genDestinationUrlTypes().INSTANT_PAGE.name &&
        !isAppProfileInstantPage.value &&
        !isLeadAdsInstantForm.value) ||
      typeName === genDestinationUrlTypes().PRODUCT_PAGE.name;

    const disableDestination = typeName => {
      if (genDestinationUrlTypes().PRODUCT_PAGE.name === typeName) {
        return false;
      }
      return disabledSelectorTab.value;
    };

    const isUrlDisable = typeName => {
      if (genDestinationUrlTypes().PRODUCT_PAGE.name === typeName) {
        return false;
      }
      return isClosedCta.value;
    };

    const checkIsShowToolTipOther = typeName => {
      const isShowUniversalLink = typeName === DestinationUrlType.destinationVisitUniversalLink;
      const isShowSchemeLink = typeName === DestinationUrlType.destinationVisitSchemeLink;
      const isShowInstantPageTip =
        typeName === genDestinationUrlTypes().INSTANT_PAGE.name &&
        (isAppProfileInstantPage.value || isLeadAdsInstantForm.value);
      return isShowInstantPageTip || isShowUniversalLink || isShowSchemeLink;
    };

    const isShowtipLink = computed(() => !isLeadAdsInstantForm.value);

    const cipLearnMoreClickTrackEvent = () => {
      trackEvent('tip_helpcenter_click');
    };

    return {
      name,
      tipHoverText,
      isShowtipLink,
      getDisabledTabText,
      isLeadAdsInstantForm,
      promotionWebsiteType,
      optimizationLocation,
      destinationUrlTypeOptions,
      DestinationUrlType,
      isEngagementPageVisit,
      getIsActive,
      setDestinationUrlType,
      checkIsShowToolTip,
      checkIsShowToolTipOther,
      getDestinationVisitTipHoverText,
      cipLearnMoreClickTrackEvent,
      disableDestination,
      isUrlDisable,
      isOptGoalDestinationVisit,
    };
  },
});
